import { OuterContentContainer } from "@themes/pollinator/ui/OuterContentContainer";
import { Loader } from "@themes/pollinator/ui/Loader";
import { useProgram } from "@platform/hooks/useProgram";
import { ProgramPhasesContainer } from "@platform/features/programPhases";
import { ProgramDialogs } from "@platform/features/programDialogs";
import { ProgramCircleContainer } from "@platform/features/programCircle";
import {
  OrgAdminActionsSectionContainer,
  OrgAdminBannerContainer,
} from "@platform/features/programOrgAdmin";
import { PendingInvitationsListContainer } from "@platform/features/invitation";
import { AppPageHeader } from "@themes/pollinator/ui/AppPageHeader";

export function DashboardProgramPage() {
  const { program, isLoading } = useProgram();

  return (
    <>
      <AppPageHeader
        title="Program Timeline"
        description="See what part of the program you're in now, and what's coming next."
      />
      <OuterContentContainer className="flex flex-1 md:pb-8 md:pt-0" innerClassName="gap-8">
        {isLoading || !program ? (
          <Loader isFullPage />
        ) : (
          <>
            <PendingInvitationsListContainer />
            <ProgramCircleContainer />
            <OrgAdminBannerContainer />
            <ProgramPhasesContainer />
            <OrgAdminActionsSectionContainer />
            <ProgramDialogs />
          </>
        )}
      </OuterContentContainer>
    </>
  );
}

export default DashboardProgramPage;
